import { SWAN_DEVELOPMENT_PROJECT_ID } from './testSchoolBootstrap';

export const DEVELOPER_SCHOOL_SELECTION_PREFIX = 'swan_developer_school_selection';

export function isDeveloperWorkspaceAvailable(projectId) {
  return projectId === SWAN_DEVELOPMENT_PROJECT_ID;
}

const selectionKey = (userId) => (
  userId ? `${DEVELOPER_SCHOOL_SELECTION_PREFIX}_${userId}` : null
);

export function getDeveloperSchoolSelection(userId, storage = globalThis.sessionStorage) {
  const key = selectionKey(userId);
  if (!key || !storage) return null;
  try {
    return storage.getItem(key) || null;
  } catch {
    return null;
  }
}

export function setDeveloperSchoolSelection(userId, schoolId, storage = globalThis.sessionStorage) {
  const key = selectionKey(userId);
  if (!key || !storage) return null;
  try {
    if (schoolId) {
      storage.setItem(key, schoolId);
      return schoolId;
    }
    storage.removeItem(key);
  } catch {
    return null;
  }
  return null;
}

export function resolveSchoolContextId({
  membershipSchoolId,
  isPlatformDeveloper,
  developerSchoolId,
}) {
  if (isPlatformDeveloper && developerSchoolId) return developerSchoolId;
  return membershipSchoolId || null;
}

export function cacheMatchesDeveloperSelection(cache, userId, storage = globalThis.sessionStorage) {
  const selectedSchoolId = getDeveloperSchoolSelection(userId, storage);
  return (cache?.developerSchoolId || null) === selectedSchoolId;
}
